<template>
  <div class="offer-content-single">
    <!-- Description Text -->
    <div
      class="offer-description"
      :style="descriptionStyle"
      v-html="formattedDescription"
    ></div>

    <!-- More Content Badge -->
    <OfferMoreContent
      :package="firstPackage"
      :display-config="packageDisplayConfig"
      :offer-display-config="displayConfig"
      :custom-style="moreContentStyle"
    />

    <!-- Old Price Badge (strikethrough) -->
    <OfferOriginalPrice
      :package="firstPackage"
      :display-config="packageDisplayConfig"
      :custom-style="originalPriceStyle"
    />

    <!-- Package Assets Display -->
    <OfferPackageAssets :package="firstPackage" :custom-style="assetsStyle" />

    <!-- CTA Button -->
    <button class="offer-cta-button" @click="handlePurchase(firstPackage)">
      {{ getCtaButtonText(firstPackage) }}
    </button>
  </div>
</template>

<script>
import { offerMethodsMixin } from "./offerMethodsMixin";
import OfferMoreContent from "./offer-more-content.vue";
import OfferOriginalPrice from "./offer-original-price.vue";
import OfferPackageAssets from "./offer-package-assets.vue";

export default {
  name: "OfferLayoutSingle",
  components: {
    OfferMoreContent,
    OfferOriginalPrice,
    OfferPackageAssets,
  },
  mixins: [offerMethodsMixin],
  props: {
    offer: {
      type: Object,
      required: true,
    },
    firstPackage: {
      type: Object,
      required: true,
    },
    displayConfig: {
      type: Object,
      default: null,
    },
    formattedDescription: {
      type: String,
      default: "",
    },
    descriptionStyle: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    packageDisplayConfig() {
      if (!this.firstPackage?.display_config) return null;
      try {
        return typeof this.firstPackage.display_config === "string"
          ? JSON.parse(this.firstPackage.display_config)
          : this.firstPackage.display_config;
      } catch (e) {
        console.error("Error parsing package display_config:", e);
        return null;
      }
    },
    moreContentStyle() {
      return {
        top: "94px",
        right: "466px",
        width: "160px",
        height: "160px",
        padding: "20px",
        fontSize: "20px",
      };
    },
    originalPriceStyle() {
      return {
        width: "110px",
        height: "43px",
        top: "512px",
        left: "603px",
        padding: "8px 16px",
        fontSize: "28px",
        lineHeight: "25px",
      };
    },
    assetsStyle() {
      return {
        top: "180px",
        left: "761px",
        height: "458px",
        width: "412px",
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "./offer-shared-styles";

// Layout-specific positioning and sizing for single package layout

.offer-description {
  left: 330px;
  top: 53%;
  transform: translateY(-50%);
  max-width: 330px;
}

.offer-cta-button {
  left: 344px;
  top: 532px;
  width: 300px;
  height: 107px;
  font-size: 32px;
  line-height: 32px;
}

// Asset sizing for single layout
::v-deep .offer-assets {
  .asset-row-other {
    gap: 10px;
  }

  .asset-item-main {
    .asset-icon {
      width: 140px;
      height: 140px;
    }

    .asset-amount {
      font-size: 42px;
    }
  }

  .asset-item-other {
    .asset-icon {
      width: 70px;
      height: 70px;
    }

    .asset-amount {
      font-size: 22px;
    }
  }
}

// More content badge text sizing
::v-deep .offer-more-content {
  .more-content-number {
    font-size: 45px;
  }

  .more-content-text {
    font-size: 20px;
    margin-top: 5px;
  }
}
</style>
